import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance"; // Import axiosInstance
import { useAuth } from "../context/AuthContext"; // Import useAuth
import "./AdminRegistrationPage.css"; // Optional for styling

const AdminRegistrationPage = () => {
  const navigate = useNavigate();
  const { authData } = useAuth();

  // Include a default "role" value in the state (e.g., "SystemAdmin")
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    password: "",
    confirmPassword: "",
    role: "SystemAdmin" // Default role required by the API
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  // Validate user input
  const validateFields = () => {
    const newErrors = {};
    if (!userData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!userData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!userData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!userData.username.trim()) newErrors.username = "Username is required";
    if (userData.password.length < 6) newErrors.password = "Password must be at least 6 characters";
    if (userData.password !== userData.confirmPassword) newErrors.confirmPassword = "Passwords do not match";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;

    setLoading(true);
    try {
      // Make sure the endpoint matches your backend route.
      const response = await axiosInstance.post("/User/admin", userData);
      setMessage("Registration successful! Please check your email for confirmation.");
      
      setTimeout(() => navigate("/login"), 3000); // Redirect after 3 sec
    } catch (error) {
      setMessage(error.response?.data?.message || "An error occurred during registration.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-registration-page">
      <div className="registration-box">
        <h2>Admin Registration</h2>
        {message && <div className="message">{message}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>First Name</label>
            <input 
              type="text" 
              name="firstName" 
              value={userData.firstName} 
              onChange={handleChange} 
              required 
            />
            {errors.firstName && <p className="error-message">{errors.firstName}</p>}
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input 
              type="text" 
              name="lastName" 
              value={userData.lastName} 
              onChange={handleChange} 
              required 
            />
            {errors.lastName && <p className="error-message">{errors.lastName}</p>}
          </div>
          <div className="form-group">
            <label>Email</label>
            <input 
              type="email" 
              name="email" 
              value={userData.email} 
              onChange={handleChange} 
              required 
            />
            {errors.email && <p className="error-message">{errors.email}</p>}
          </div>
          <div className="form-group">
            <label>Username</label>
            <input 
              type="text" 
              name="username" 
              value={userData.username} 
              onChange={handleChange} 
              required 
            />
            {errors.username && <p className="error-message">{errors.username}</p>}
          </div>
          <div className="form-group">
            <label>Password</label>
            <input 
              type="password" 
              name="password" 
              value={userData.password} 
              onChange={handleChange} 
              required 
            />
            {errors.password && <p className="error-message">{errors.password}</p>}
          </div>
          <div className="form-group">
            <label>Confirm Password</label>
            <input 
              type="password" 
              name="confirmPassword" 
              value={userData.confirmPassword} 
              onChange={handleChange} 
              required 
            />
            {errors.confirmPassword && <p className="error-message">{errors.confirmPassword}</p>}
          </div>
          {/* Hidden role field */}
          <input type="hidden" name="role" value={userData.role} />
          <button type="submit" disabled={loading}>
            {loading ? "Registering..." : "Register"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminRegistrationPage;
